export default __webpack_public_path__ + "static/media/SD-gallery-04.63cfb6ad.png";